import React from "react";
import Image from "react-bootstrap/Image";

import AvatarPlaceholder from "assets/images/pet-avatar.svg";

import "./Avatar.css";

type AvatarProps = {
  name?: string;
  src?: string;
  rounded?: boolean;
};

const Avatar = ({ name, src, rounded }: AvatarProps) => {
  // cosnole.log("name of avatar ",name);
  return (
    <div className="oc-avatar d-flex align-items-center">
      <Image
        className="tw-h-14 tw-w-14 tw-object-cover lg:tw-w-20 lg:tw-h-20 tw-rounded-[100%]"
        src={src || AvatarPlaceholder}
        roundedCircle={rounded}
        alt="avatar"
      />
      {name && <span className="oc-avatarName">{name}</span>}
    </div>
  );
};

export default Avatar;
